// Itens individuais com valores para a seção de Value Recap
export const PRODUCT_ITEMS = [
  {
    icon: 'CheckSquare',
    emoji: '✅',
    title: 'Checklist de QT',
    description: 'Checklists de pré, durante e pós-quimioterapia para nunca esquecer nenhuma etapa crítica.',
    value: 'R$ 97,00'
  },
  {
    icon: 'Brain',
    emoji: '🧠',
    title: 'Mapa Mental Oncológico',
    description: 'Cuidados organizados visualmente por categorias para consulta rápida no plantão.',
    value: 'R$ 67,00'
  },
  {
    icon: 'AlertTriangle',
    emoji: '⚠️',
    title: 'Protocolos de Intercorrências',
    description: 'Condutas imediatas para 13 intercorrências oncológicas baseadas em evidências.',
    value: 'R$ 87,00'
  },
  {
    icon: 'Calculator',
    emoji: '🧮',
    title: 'Calculadoras Clínicas',
    description: 'MASCC, ECOG, EVA e Velocidade de Infusão — cálculo em segundos no plantão.',
    value: 'R$ 77,00'
  },
  {
    icon: 'FlaskConical',
    emoji: '🧪',
    title: 'Classificação de Antineoplásicos',
    description: '26+ drogas com antídotos e condutas para extravasamento de cada uma.',
    value: 'R$ 97,00'
  },
  {
    icon: 'BookOpen',
    emoji: '📚',
    title: 'Guias Educativos — 4 Cartilhas',
    description: 'Protocolos, fluxogramas, tabelas de compatibilidade e escalas validadas em PDF.',
    value: 'R$ 67,00'
  },
  {
    icon: 'HelpCircle',
    emoji: '🏆',
    title: 'Quiz Clínico — 95+ Perguntas',
    description: '5 módulos temáticos com feedback imediato para fixar o aprendizado.',
    value: 'R$ 57,00'
  },
  {
    icon: 'Zap',
    emoji: '🚨',
    title: 'Emergências — Código de Plantão',
    description: '7 protocolos detalhados para as principais emergências oncológicas.',
    value: 'R$ 127,00'
  }
];

// Stats de prova social
export const SOCIAL_PROOF_STATS = [
  { icon: 'Users', value: '500+', label: 'enfermeiros ativos na plataforma' },
  { icon: 'FileQuestion', value: '95+', label: 'questões no quiz clínico' },
  { icon: 'BookOpen', value: '26+', label: 'drogas antineoplásicas mapeadas' },
  { icon: 'Calculator', value: '4', label: 'calculadoras clínicas disponíveis' }
];

export const MODULES = [
  {
    icon: 'CheckSquare',
    emoji: '✅',
    title: 'Checklist de QT',
    subtitle: 'Segurança',
    description: 'Checklists de pré, durante e pós-quimioterapia. Nunca esqueça nenhuma etapa crítica no seu plantão.',
    tag: 'Essencial'
  },
  {
    icon: 'Brain',
    emoji: '🧠',
    title: 'Mapa Mental',
    subtitle: 'Conhecimento',
    description: 'Cuidados de enfermagem oncológica organizados visualmente por categorias para consulta rápida.',
    tag: 'Referência'
  },
  {
    icon: 'AlertTriangle',
    emoji: '⚠️',
    title: 'Intercorrências',
    subtitle: 'Urgência',
    description: 'Protocolos de manejo de 13 intercorrências oncológicas com condutas imediatas baseadas em evidências.',
    tag: '13 protocolos'
  },
  {
    icon: 'Calculator',
    emoji: '🧮',
    title: 'Calculadoras Clínicas',
    subtitle: '4 Calculadoras',
    description: 'MASCC (neutropenia febril), ECOG/Performance Status, EVA/NRS (escala de dor) e Velocidade de Infusão. Cálculo em segundos.',
    tag: '4 ferramentas'
  },
  {
    icon: 'FlaskConical',
    emoji: '🧪',
    title: 'Classificação de Antineoplásicos',
    subtitle: '26+ Drogas',
    description: '26+ drogas classificadas: vesicantes, irritantes e não-vesicantes com antídotos específicos e condutas para extravasamento.',
    tag: '26+ drogas'
  },
  {
    icon: 'BookOpen',
    emoji: '📚',
    title: 'Guias Educativos',
    subtitle: '4 Cartilhas',
    description: 'Material completo em 4 cartilhas para consulta offline: protocolos, fluxogramas, tabelas de compatibilidade e escalas validadas.',
    tag: '4 cartilhas'
  },
  {
    icon: 'HelpCircle',
    emoji: '🏆',
    title: 'Quiz Clínico',
    subtitle: '95+ Perguntas',
    description: '95+ perguntas clínicas em 5 módulos temáticos com feedback imediato e pontuação para fixar o aprendizado.',
    tag: '5 módulos'
  },
  {
    icon: 'Zap',
    emoji: '🚨',
    title: 'Emergências — Código de Plantão',
    subtitle: '7 Protocolos',
    description: 'Protocolos detalhados para as 7 principais emergências: neutropenia febril, extravasamento, anafilaxia, sepse oncológica, lise tumoral, compressão medular e hipercalcemia.',
    tag: '7 emergências'
  }
];

export const HERO_STATS = [
  { value: '8', label: 'módulos interativos' },
  { value: '4', label: 'calculadoras clínicas' },
  { value: '26+', label: 'drogas classificadas' },
  { value: '7', label: 'protocolos de emergência' },
  { value: '95+', label: 'questões de quiz' },
  { value: '13', label: 'intercorrências mapeadas' }
];

export const PAIN_POINTS = [
  'Plantão começou e você não lembra os critérios exatos de neutropenia febril.',
  'O paciente está em extravasamento e você perde segundos procurando o protocolo certo.',
  'A classificação da droga vesicante que você precisa está em algum livro... mas qual mesmo?',
  'O quiz que você fez na faculdade não prepara para a velocidade real do plantão oncológico.',
  'Tem material em PDF espalhado em pastas, grupos do WhatsApp e apostilas antigas.'
];

export const FOR_WHO = [
  'Enfermeiros que atuam em clínicas de quimioterapia',
  'Técnicos de enfermagem oncológica',
  'Residentes de enfermagem em oncologia',
  'Profissionais em preparação para especialização',
  'Enfermeiros de UTI oncológica e hemato-oncologia',
  'Profissionais que precisam de atualização clínica rápida'
];

export const TESTIMONIALS = [
  {
    name: 'Carla M.',
    role: 'Enfermeira Oncológica',
    city: 'São Paulo - SP',
    quote: 'Estava no plantão e um paciente começou a apresentar sinais de extravasamento. Abri o módulo de Classificação de Antineoplásicos e em menos de 30 segundos já sabia o antídoto exato. Isso não tem preço.',
    stars: 5
  },
  {
    name: 'Diego R.',
    role: 'Técnico de Enfermagem em QT',
    city: 'Belo Horizonte - MG',
    quote: 'A calculadora MASCC me ajudou a identificar um paciente de alto risco que precisava de internação. Antes eu esperava o médico calcular. Agora chego com o escore na mão. Mudou minha postura no plantão.',
    stars: 5
  },
  {
    name: 'Fernanda K.',
    role: 'Enfermeira Residente — Hemato-Oncologia',
    city: 'Curitiba - PR',
    quote: 'Passei pelo plantão mais difícil da minha residência com um caso de neutropenia febril. O protocolo detalhado com o bundle de 60 minutos me guiou em cada passo. Sem a Jornada eu teria entrado em pânico.',
    stars: 5
  },
  {
    name: 'Rafaela S.',
    role: 'Enfermeira — UTI Oncológica',
    city: 'Recife - PE',
    quote: 'A seção de emergências é simplesmente indispensável. Tive um caso de hipercalcemia grave e segui o protocolo passo a passo. A equipe médica ficou impressionada com a agilidade da minha conduta.',
    stars: 5
  },
  {
    name: 'Marcos T.',
    role: 'Enfermeiro Oncológico',
    city: 'Porto Alegre - RS',
    quote: 'Finalmente uma ferramenta feita para a realidade do plantão. Sem enrolação, sem teoria demais. Abro, consulto e já sei o que fazer. Instalei no celular e tenho tudo ao alcance. Perfeito.',
    stars: 5
  }
];

export const FAQS = [
  {
    question: 'O acesso é imediato?',
    answer: 'Sim. Após a confirmação da compra, você recebe acesso imediato à plataforma Jornada Oncológica na Prática.'
  },
  {
    question: 'O produto é um curso ou uma plataforma?',
    answer: 'É uma plataforma prática de consulta clínica, com módulos, checklists, calculadoras, protocolos, mapas mentais, quiz e materiais de apoio para enfermagem oncológica.'
  },
  {
    question: 'Posso acessar pelo celular?',
    answer: 'Sim. A plataforma foi pensada para acesso rápido pelo celular, tablet ou computador, inclusive durante a rotina de plantão.'
  },
  {
    question: 'O conteúdo serve para quem está começando na oncologia?',
    answer: 'Sim. Ele ajuda tanto quem está iniciando quanto quem já atua na área e quer ter protocolos, condutas e materiais organizados em um só lugar.'
  },
  {
    question: 'O que está incluído?',
    answer: 'Você terá acesso a módulos interativos, calculadoras clínicas, classificação de antineoplásicos, protocolos de emergências oncológicas, checklist de quimioterapia, mapas mentais, quiz clínico e biblioteca de cartilhas.'
  },
  {
    question: 'O material é baseado em evidências?',
    answer: 'Sim. O conteúdo foi estruturado com foco em prática segura, protocolos clínicos e referências utilizadas na assistência oncológica.'
  },
  {
    question: 'Tem garantia?',
    answer: 'Sim. Você conta com 7 dias de garantia para testar a plataforma com tranquilidade.'
  }
];

export const EMERGENCY_PROTOCOLS = [
  {
    name: 'Anafilaxia',
    severity: 'destructive',
    keyInfo: 'Adrenalina IM 0,3-0,5mg (1:1000) na face anterolateral da coxa. Repetir a cada 5-15min se necessário. O2 suplementar, acesso venoso calibroso, SF 0,9% 1000mL rápido.'
  },
  {
    name: 'Extravasamento Vesicante',
    severity: 'destructive',
    keyInfo: 'Parar infusão imediatamente. Aspirar resíduo pelo cateter. Aplicar compressas frias (exceto vinca-alcaloides e taxanos). Documentar área, droga, volume. Acionar médico para antídoto específico.'
  },
  {
    name: 'Neutropenia Febril',
    severity: 'destructive',
    keyInfo: 'Febre ≥38°C + neutrófilos <500/mm³ = EMERGÊNCIA. Coletar 2 hemoculturas de sítios diferentes. Antibiótico de amplo espectro em até 1 hora (Piperacilina-Tazobactam ou Cefepime).'
  },
  {
    name: 'Síndrome de Lise Tumoral',
    severity: 'destructive',
    keyInfo: 'Hiperuricemia, hipercalemia, hiperfosfatemia, hipocalcemia. Hidratação vigorosa (3L/m²/dia), Alopurinol 300mg VO ou Rasburicase IV. Monitorar função renal e eletrólitos 6/6h.'
  },
  {
    name: 'Compressão Medular',
    severity: 'destructive',
    keyInfo: 'Dor lombar + fraqueza em MMII + alteração esfincteriana = URGÊNCIA NEUROCIRÚRGICA. Dexametasona 10mg IV imediato. RNM coluna total em <24h. Não mobilizar paciente até avaliação.'
  },
  {
    name: 'Hipercalcemia Grave',
    severity: 'primary',
    keyInfo: 'Ca >14mg/dL ou sintomático. SF 0,9% 200-300mL/h (4-6L/dia). Furosemida após reidratação. Pamidronato 90mg IV em 2h ou Ácido Zoledrônico 4mg IV em 15min. Monitorar K, Mg, função renal.'
  },
  {
    name: 'Sepse/Choque Séptico',
    severity: 'destructive',
    keyInfo: 'Pacote 1h: Lactato, hemocultura, antibiótico, cristaloide 30mL/kg. qSOFA ≥2 (FR≥22, PAS≤100, alteração consciência) = alto risco. Noradrenalina se PAM <65mmHg após volume.'
  }
];

export const REFERENCES = [
  'ESMO Clinical Practice Guidelines',
  'ASCO Guidelines',
  'ABHH — Associação Brasileira de Hematologia',
  'INCA — Instituto Nacional de Câncer',
  'EBSERH Protocolos Clínicos',
  'Surviving Sepsis Campaign'
];

export const ROUTE_PATHS = {
  HOME: '/'
};